// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2CsXF","filesListContainer":"PosDisputesFiles_filesListContainer__32dYg","filesButton":"PosDisputesFiles_filesButton__oOFD3"};